
export const AlignTextCenter = ({color="#4E4B66", size=20}: {color?: string, size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3333 8.33333H6.66667M15 5H5M15 11.6667H5M13.3333 15H6.66667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg> 
  );
}